import { ProviderClient } from '../../abstract/provider.client'
import { PROPERTY_INDEXER_NODES } from '../../abstract/provider.objects'
import { ProviderIndexerCommon } from '../common'

export const ProviderIndexerClient: ProviderClient = {
  key: ProviderIndexerCommon.key,
  description: {
    icon: <i className="las la-file-invoice" style={{ fontSize: '20px' }}></i>,
    label: 'Indexer',
    triggers: [],
    actions: [
      {
        key: 'createNodes',
        label: 'Create Nodes',
        input: [
          {
            key: 'values',
            type: 'array_objects',
            properties: [
              { key: 'content', type: 'string' },
              { key: 'contentEmbedding', type: 'string' },
              { key: 'tags', type: 'array' },
            ],
          },
        ],
        output: [PROPERTY_INDEXER_NODES],
      },
      {
        key: 'findNodes',
        label: 'Find Nodes',
        input: [
          {
            key: 'query',
            type: 'string',
          },
          {
            key: 'tags',
            type: 'array',
            propsFormItem: {
              required: false,
            },
          },
        ],
        output: [PROPERTY_INDEXER_NODES],
      },
    ],
  },
}
